import React, { useState } from "react";
import { api, apiErr, mediaUrl } from "../../lib/api";
import { toast } from "sonner";
import { Plus, Trash2, ImagePlus, ArrowUp, ArrowDown } from "lucide-react";

export function ArrivalStepsEditor({ steps, onChange }) {
  const [uploading, setUploading] = useState(-1);
  const list = steps || [];
  const set = (i, patch) => onChange(list.map((s, j) => (j === i ? { ...s, ...patch } : s)));
  const move = (i, d) => {
    const j = i + d;
    if (j < 0 || j >= list.length) return;
    const a = [...list]; [a[i], a[j]] = [a[j], a[i]]; onChange(a);
  };
  const upload = async (i, file) => {
    if (!file) return;
    setUploading(i);
    try {
      const fd = new FormData(); fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      set(i, { image: data.url });
    } catch (e) { toast.error(apiErr(e)); } finally { setUploading(-1); }
  };
  return (
    <div className="rounded-lg border border-brand/20 bg-brand-50/30 p-3 space-y-3" data-testid="arrival-steps-editor">
      <div>
        <p className="text-sm font-medium text-ink-900">Instructions d'arrivée autonome</p>
        <p className="text-xs text-ink-400">Visibles par le client uniquement après paiement du lien d'arrivée (où est la clé, chemin jusqu'à la porte…).</p>
      </div>
      {list.map((st, i) => (
        <div key={i} className="flex gap-3 rounded-lg bg-white p-2 ring-1 ring-black/5" data-testid={`arrival-step-${i}`}>
          <label className="relative w-24 h-24 shrink-0 rounded-lg bg-slate-100 overflow-hidden flex items-center justify-center cursor-pointer text-slate-400 hover:bg-slate-200" data-testid={`arrival-step-photo-${i}`}>
            {st.image ? <img src={mediaUrl(st.image)} alt="" className="w-full h-full object-cover" /> : <ImagePlus size={22} />}
            {uploading === i && <span className="absolute text-[10px]">…</span>}
            <input type="file" accept="image/*" className="hidden" onChange={(e) => upload(i, e.target.files?.[0])} />
          </label>
          <textarea rows={4} value={st.text || ""} onChange={(e) => set(i, { text: e.target.value })} placeholder={`Étape ${i + 1} : ex. La clé se trouve dans la boîte à gauche de la porte…`} className="flex-1 rounded border border-slate-200 px-2 py-1.5 text-sm text-ink-900" data-testid={`arrival-step-text-${i}`} />
          <div className="flex flex-col gap-1 text-slate-400">
            <button type="button" onClick={() => move(i, -1)} className="hover:text-brand" aria-label="Monter" data-testid={`arrival-step-up-${i}`}><ArrowUp size={15} /></button>
            <button type="button" onClick={() => move(i, 1)} className="hover:text-brand" aria-label="Descendre" data-testid={`arrival-step-down-${i}`}><ArrowDown size={15} /></button>
            <button type="button" onClick={() => onChange(list.filter((_, j) => j !== i))} className="text-red-500 hover:text-red-700" data-testid={`arrival-step-remove-${i}`}><Trash2 size={15} /></button>
          </div>
        </div>
      ))}
      <button type="button" onClick={() => onChange([...list, { text: "", image: "" }])} className="text-brand text-xs inline-flex items-center gap-1" data-testid="arrival-step-add"><Plus size={13} /> Ajouter une étape (photo + explication)</button>
    </div>
  );
}
